import React, { useLayoutEffect, useState } from 'react'
import classNames from 'classnames'
import { formatTimeAgo } from '../../utils/helpers'
import Link from 'next/link'
import styles from './NotificationItems.module.scss'

const NotificationItems = ({
  notifications,
  msgRefs,
  handleUpdateIsMuted,
  handleUpdateIsSeen,
  fromDropdown = false,
  isDropdownOpen = false
}) => {
  const [isFullDesc, setIsFullDesc] = useState([])
  const [hasActionLinks, setHasActionLinks] = useState([])

  useLayoutEffect(() => {
    const tempIsFullDesc = Object.assign([], isFullDesc)
    const tempActionLinks = Object.assign([], hasActionLinks)

    msgRefs.forEach((ref, i) => {
      tempIsFullDesc[i] = false
      tempActionLinks[i] = true
      let element = msgRefs[i].current
      if (element && element.clientHeight == element.scrollHeight) {
        tempActionLinks[i] = false
      }
    })
    setIsFullDesc(tempIsFullDesc)
    setHasActionLinks(tempActionLinks)
  }, [msgRefs, isDropdownOpen])

  const handleIsFullDesc = (index, isFull, e) => {
    e.preventDefault()
    const temp = Object.assign({}, isFullDesc)
    temp[index] = isFull
    setIsFullDesc(temp)
  }

  const showItem = (item) => {
    let show = false
    if (!fromDropdown || (fromDropdown && !item.isMuted)) {
      show = true
    }
    return show
  }

  return (
    <div className={classNames(styles.items, { 'items-dropdown-content': fromDropdown })}>
      {notifications.map(
        (item, index) =>
          showItem(item) && (
            <div
              key={`notification-${index}`}
              className={classNames(styles.itemContainer, styles[item.notificationType], {
                [styles.newNotif]: !item.isSeen
              })}
              onClick={(e) => handleUpdateIsSeen(index, item)}
              role="button"
              tabIndex={0}
            >
              <div className={styles.visibilityLinkContainer}>
                <a
                  href="#"
                  onClick={(e) =>
                    handleUpdateIsMuted(index, item.notificationMachineName, item.isMuted, e)
                  }
                  className="visibilityLink"
                >
                  {item.isMuted ? 'Show' : 'Hide'}
                </a>
              </div>
              <p className={styles.title}>{item.title}</p>
              <p className={styles.date}>{formatTimeAgo(item.created_at)}</p>
              <div
                className={classNames(styles.description, { partial: !isFullDesc[index] })}
                ref={msgRefs[index]}
                dangerouslySetInnerHTML={{ __html: item.notificationMessage }}
              />
              <div className={classNames(styles.linksContainer, 'row justify-content-between')}>
                <div className="col-auto">
                  {item.actionText && item.actionUrl ? (
                    <Link href={item.actionUrl} target="_blank" rel="noreferrer">
                      <a className={classNames(styles.actionLink, 'visible')}>{item.actionText}</a>
                    </Link>
                  ) : null}
                </div>
                {hasActionLinks[index] && (
                  <div className="col-auto">
                    <a
                      className={styles.actionLink}
                      href="#"
                      onClick={(e) => handleIsFullDesc(index, !isFullDesc[index], e)}
                    >
                      {isFullDesc[index] ? 'SHOW LESS' : 'SHOW MORE'}
                    </a>
                  </div>
                )}
              </div>
            </div>
          )
      )}
    </div>
  )
}

export default NotificationItems
